import { useState, useEffect } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import NewsPackages from './NewsPackages';
import { styles, headerWIthMultipleLines, headerWithLink, textWithIcon, fetchData, renderPreText, onCellClicked, cellWithMultipleLines, textWithTextIcon, headerwithTooltip } from './Helpers';
import commentImg from '../../images/comment.svg';

export default function Packages() {
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [overlayFlag, setOverlayFlag] = useState(0);
  const [dataFieldsData, setDataFieldsData] = useState([]);
  const [topicCodesData, setTopicCodesData] = useState([]);
  const [thirdPartySourcesData, setThirdPartySourcesData] = useState([]);
  const [languagesData, setLanguagesData] = useState([]);
  const [olSearchData, setOlSearchData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.reportType.toLowerCase().includes(val.toLowerCase())));
  }

  function olSearchEvent(val) {
    if(overlayFlag === 1) {
      setOlSearchData(dataFieldsData.filter(item => item.fieldPath.toLowerCase().includes(val.toLowerCase())));
    }else if(overlayFlag === 2){
      setOlSearchData(topicCodesData.filter(item => item.label.toLowerCase().includes(val.toLowerCase())));
    }else if(overlayFlag === 3){
      setOlSearchData(thirdPartySourcesData.filter(item => item.description.toLowerCase().includes(val.toLowerCase())));
    }
  }

  function rowExpander(e) {
    let rowData = e.originalRowData;
    var data = rowData ? rowData["description"] : [];
    let rowIndex = e["rowIndex"];
    let section = e["section"];
    let cell = section.stretchCell(0, rowIndex, true);

    if (e.rowExpansion && rowData) {
      cell.setStyle("backgroundColor", "#FFFFFF");
      section.setRowHeight(rowIndex, 200);

      let expContent = cell.getContent();
      if (!expContent || !expContent._myExpansion) {
        expContent = document.createElement("div");
        expContent._myExpansion = true;

        let firstLine = expContent._firstLine = document.createElement("ef-layout");
        firstLine.style.display = "flex";
        let secondLine = expContent._secondLine = document.createElement("ef-layout");
        secondLine.style.paddingBottom = "10px";
        let thridLine = expContent._thirdLine = document.createElement("ef-layout");
        thridLine.style.paddingLeft = "5px";
        thridLine.style.marginTop = "10px";

        let descImage = document.createElement("img");
        descImage.src = commentImg;
        descImage.style.marginRight = "10px";
        descImage.style.width = "24px";
        descImage.style.height = "24px";
        firstLine.appendChild(descImage);
        let descText = document.createElement("h2");
        descText.textContent = "Description";
        descText.style.fontWeight = "600";
        descText.style.fontSize = "16px";
        descText.style.color = "#001eff";
        descText.style.margin = "0px";
        firstLine.appendChild(descText);

        let descLayout = document.createElement("ef-layout");
        descLayout.style.width = "90%";
        descLayout.style.whiteSpace = "pre-wrap";
        descLayout.style.wordWrap = "break-word";
        descLayout.style.overflowWrap = "break-word";
        descLayout.style.fontWeight = "400";
        descLayout.style.backgroundColor = "transparent";
        descLayout.style.color = "#666666";
        descLayout.style.border = "none";
        descLayout.style.padding = "10px 30px 10px 0px";
        descLayout.style.margin = "10px 5px";
        descLayout.style.fontSize = "16px";
        descLayout.innerHTML = data.replace(/\n/g, " ");
        secondLine.appendChild(descLayout);

        let btns = ["Data Fields", "RCS Topic Codes", "3rd Party Sources", "Languages"];
        let btnIcons = ["data-fields", "topic", "third-party", "timeline"];
        btns.forEach((btn, index) => {
          let button = document.createElement("ef-button");
          let btnSpan = document.createElement("span");
          btnSpan.textContent = btn;
          btnSpan.style.marginRight = "5px";
          let btnIcon = document.createElement("img");
          btnIcon.style.height = "16px";
          btnIcon.style.verticalAlign = "middle";
          btnIcon.style.marginRight = "5px";
          btnIcon.src = `${resolveImage(btnIcons[index])}`;
          button.appendChild(btnIcon);
          button.appendChild(btnSpan);
          button.style.marginRight = "10px";
          button.style.backgroundColor = "transparent";
          button.style.textDecoration = "underline";
          button.style.color = "#001eff";
          button.style.border = "none";
          button.style.padding = "6px 12px";
          button.style.borderRadius = "4px";
          button.addEventListener("click", () => {
            setOverlayFlag(index + 1);
          });
          thridLine.appendChild(button);
        });

        expContent.appendChild(firstLine);
        expContent.appendChild(secondLine);
        expContent.appendChild(thridLine);
      }

      rowData = e.originalRowData;
      cell.setContent(expContent);
    } else {
      // dispose
      cell = section.stretchCell(0, rowIndex, false);
      cell.setStyle("backgroundColor", "");
      section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
    }
  }

  function textWithLink(e) {
    let cell = e.cell;
    let content = cell.getContent();
    const tabs = {
      "Reuters Equity\n& Markets News": "News_Reuters_News",
      "3rd Party News": "News_3rd_Party_News",
      "Top News": "News_Top_News",
      "Online Reports": "News_Online_Reports",
      "BreakingViews": "News_Breakingviews",
      "Significant Developments Service": "News_Significant_Development",
      "Japanese Investor Briefs": "News_Japanese_Investor_Brief",
    }
    if(!content || !content._myTextBtn) {
      content = document.createElement("div");
      content._myTextBtn = true;
      content._myLinkIcon = true;
      let btnIcon = content._myBtnIcon = document.createElement("ef-icon");
      btnIcon.icon = "right";
      btnIcon.style.marginRight = "10px";
      btnIcon.style.color = "#0F1E8A";
      btnIcon.style.fontSize = "14px";
      let textButton = content._myTextBtn = document.createElement("ef-button");
      textButton.style.color = "#0F1E8A";
      textButton.style.textDecoration = "none";
      textButton.style.padding = "0";
      textButton.style.backgroundColor = "transparent";
      textButton.style.border = "none";
      textButton.style.width = "auto";
      textButton.style.height = "100%";
      textButton.style.textAlign = "left";
      content.appendChild(btnIcon);
      content.appendChild(textButton);
      let linkIcon = content._myLinkIcon = document.createElement("ef-icon");
      linkIcon.style.color = "#0F1E8A";
      linkIcon.icon = "link";
      linkIcon.style.backgroundColor = "#E8F2FF";
      linkIcon.style.float = "right";
      linkIcon.style.padding = "4px";
      linkIcon.style.borderRadius = "20px";
      content.appendChild(linkIcon);
    }
    content._myTextBtn.textContent = e.data;
    content._myTextBtn.onclick = function() {
      if (content._myBtnIcon.icon === "right") {
        content._myBtnIcon.icon = "down";
      } else {
        content._myBtnIcon.icon = "right";
      }
    }
    content._myLinkIcon.id = tabs[e.data.trim()];
    content._myLinkIcon.onclick = function() {
      setSelectedPackage(content._myLinkIcon.id);
    };
    cell.setContent(content);
  }

  useEffect(() => {
    fetchData("News_Packages").then((res) => {
      setFullData(res);
      setLoading(false);
    });
  }, [])

  useEffect(() => {
    const grid = document.getElementById('grid');
    grid.addEventListener("click", onCellClicked);
  }, [selectedPackage])

  useEffect(() => {
    setLoading(true);
    setOlSearchData([]);
    if(overlayFlag === 1){
      fetchData("News_Data_Fields").then((res) => {
        setDataFieldsData(res);
        setLoading(false);
      });
    }else if(overlayFlag === 2){
      fetchData("News_RCS_Topic_Codes").then((res) => {
        setTopicCodesData(res);
        setLoading(false);
      });
    }else if(overlayFlag === 3){
      fetchData("News_3rd_Party_Sources").then((res) => {
        setThirdPartySourcesData(res);
        setLoading(false);
      });
    }else if(overlayFlag === 4){
      fetchData("News_Languages").then((res) => {
        setLanguagesData(res);
        setLoading(false);
      });
    }else{
      setLoading(false);
    }
  }, [overlayFlag])

  useEffect(() => {
    const grid = document.getElementById('dataFieldsGrid');
    grid.config = {
      rowHeight: 90,
      headerRowHeight: 50,
      columns: [
        { name: 'Field Path', field: 'fieldPath', width: 2, scalable: true, binding: cellWithMultipleLines},
        { name: 'Base Field', field: 'baseField', width: 1, scalable: true},
        { name: 'Example Value', field: 'exampleValue', width: 2, scalable: true, binding: cellWithMultipleLines},
        { name: 'Description', field: 'description', width: 3, scalable: true, binding: cellWithMultipleLines},
        { name: 'Headline', field: 'headline', width: 1, scalable: true, binding: textWithIcon},
        { name: 'Body', field: 'body', width: 1, scalable: true, binding: textWithIcon},
        { name: 'Archive', field: 'archive', width: 1, scalable: true, binding: textWithIcon}
      ],
      dataModel: {
        data: olSearchData.length > 0 ? olSearchData : dataFieldsData
      }
    };
  }, [dataFieldsData, olSearchData])

  useEffect(() => {
    const tcGrid = document.getElementById('tcGrid');
    tcGrid.config = {
      rowHeight: 90,
      headerRowHeight: 50,
      columns: [
        { name: 'ID', field: 'id', width: 1, scalable: true},
        { name: 'Readable', field: 'reaadable', width: 2, scalable: true},
        { name: 'Label', field: 'label', width: 3, scalable: true, binding: cellWithMultipleLines},
        { name: 'Description', field: 'description', width: 4, scalable: true, binding: cellWithMultipleLines},
        { name: 'Group', field: 'group', width: 1, scalable: true},
        { name: 'Searchable', field: 'searchable', width: 1, scalable: true, binding: textWithIcon},
        { name: 'Children Count', field: 'childrenCount', width: 1, scalable: true}
      ],
      dataModel: {
        data: olSearchData.length > 0 ? olSearchData : topicCodesData
      }
    };
  }, [topicCodesData, olSearchData])

  useEffect(() => {
    const tpGrid = document.getElementById('tpsGrid');
    tpGrid.config = {
      rowHeight: 90,
      headerRowHeight: 50,
      columns: [
        { name: 'Source Code', field: 'newsSourceCode', width: 1, scalable: true},
        { name: 'Description', field: 'description', width: 3, scalable: true, binding: cellWithMultipleLines},
        { name: 'Supplier', field: 'supplier', width: 3, scalable: true, binding: cellWithMultipleLines},
        { name: 'Primary Coverage Region', field: 'primaryCoverageRegion', width: 1, scalable: true},
        { name: 'Country Specific Coverage', field: 'countrySpecificCoverage', width: 1, scalable: true},
        { name: 'All or Partially English', field: 'allOrPartiallyEnglish', width: 1, scalable: true, binding: textWithIcon},
        { name: 'Pro Users Access Rules', field: 'proUserAccessRules', width: 2, scalable: true, binding: textWithTextIcon, headerBinding: headerwithTooltip.bind(null, "*incl. in Unrestricted Pro News Package")},
        { name: 'Redistribution Rules Private', field: 'redistributionRulesPrivate', width: 2, scalable: true, binding: textWithTextIcon, headerBinding: headerwithTooltip.bind(null, "**incl. in Unrestricted Private News Package")},
        { name: 'Redistribution Rules Public', field: 'redistributionRulesPublic', width: 2, scalable: true, binding: textWithTextIcon, headerBinding: headerwithTooltip.bind(null, "***incl. in Unrestricted Public News Package")}
      ],
      dataModel: {
        data: olSearchData.length > 0 ? olSearchData : thirdPartySourcesData
      }
    };
  }, [thirdPartySourcesData, olSearchData])

  useEffect(() => {
    const langGrid = document.getElementById('languagesGrid');
    langGrid.config = {
      rowHeight: 90,
      headerRowHeight: 50,
      columns: [
        { name: 'Language', field: 'language', width: 1, scalable: true},
        { name: 'Language Code', field: 'languageCode', width: 1, scalable: true}
      ],
      dataModel: {
        data: olSearchData.length > 0 ? olSearchData : languagesData
      }
    };
  }, [languagesData, olSearchData]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'PACKAGE', field: 'reportType', width: 3, scalable: true, binding: textWithLink},
      { name: 'PUBLIC', field: 'public', width: 2, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "free"), styles: styles, binding: renderPreText},
      { name: 'PRIVATE', field: 'private', width: 2, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "private"), binding: renderPreText},
      { name: 'INTERNAL PROFESSIONAL', field: 'professional', width: 2.5, scalable: true, headerBinding: headerWithLink.bind(null, "Private", "professional"), styles: styles, binding: renderPreText },
      { name: 'Streaming Alert Message Service' , field: 'messageService', width: 1.5, scalable: true, binding: textWithIcon, headerBinding: headerWIthMultipleLines},
      { name: 'REST API Service' , field: 'apiService', width: 1.5, scalable: true, binding: textWithIcon,headerBinding: headerWIthMultipleLines, styles: styles}
    ]

    if(selectedPackage === null){
      grid.config = {
        rowHeight: 150,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData,
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index`
              sortOrder: "a"
          }
        },
        rowExpansionBinding: rowExpander
      };
    }
  }, [fullData, searchData, selectedPackage]);

  return (
    <div className="main-div">
      <ef-overlay className="news-overlay" with-backdrop with-shadow no-cancel-on-esc-key no-cancel-on-outside-click opened={overlayFlag === 1}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Data Fields</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setOverlayFlag(0)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
            <input
            className='search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => olSearchEvent(e.target.value)}
          />
        </ef-layout>
        <ef-layout><efx-grid id="dataFieldsGrid" ></efx-grid></ef-layout>
      </ef-overlay>
      <ef-overlay className="news-overlay" with-backdrop with-shadow no-cancel-on-esc-key no-cancel-on-outside-click opened={overlayFlag === 2}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>RCS Topic Codes</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setOverlayFlag(0)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
            <input
            className='search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => olSearchEvent(e.target.value)}
          />
        </ef-layout>
        <ef-layout><efx-grid id="tcGrid" ></efx-grid></ef-layout>
      </ef-overlay>
      <ef-overlay className="news-overlay" with-backdrop with-shadow no-cancel-on-esc-key no-cancel-on-outside-click opened={overlayFlag === 3}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>3rd Party Sources</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setOverlayFlag(0)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout>
            <input
            className='search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => olSearchEvent(e.target.value)}
          />
        </ef-layout>
        <ef-layout><efx-grid id="tpsGrid" ></efx-grid></ef-layout>
      </ef-overlay>
      <ef-overlay className="news-languages-overlay" with-backdrop with-shadow no-cancel-on-esc-key no-cancel-on-outside-click opened={overlayFlag === 4}>
        <ef-layout flex className="overlay-header">
          <ef-layout><h5>Languages</h5></ef-layout>
          <ef-layout className="right"><ef-button icon="cross" transparent onClick={() => setOverlayFlag(0)}></ef-button></ef-layout>
        </ef-layout>
        <ef-layout><efx-grid id="languagesGrid" ></efx-grid></ef-layout>
      </ef-overlay>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {selectedPackage !== null && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setSelectedPackage(null)}>Back to NEWS Packages</ef-button>
          <NewsPackages tab={selectedPackage} />
        </div>
      )}
      {selectedPackage === null && (<>
        <h4>News Packages</h4>
        <ef-layout flex style={{ marginTop: '20px' }}>
          <ef-layout>
              <input
              className='search-field'
              type="text"
              placeholder="Type to search..."
              onChange={(e) => searchEvent(e.target.value)}
            />
          </ef-layout>
        </ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </>)}
    </div>
  );
}